import React, { PropsWithChildren } from 'react';

import List, { IListOptions } from 'devextreme-react/list.js';

const NavigationList: React.FC<PropsWithChildren<IListOptions>> = ({ dataSource, onItemClick, selectedItemKeys, ...props }) => {

//const NavigationList = ({ dataSource, onItemClick }) => {
    return (
        <div className="navigation-list"
        >
            <List
                dataSource={dataSource}
//                hoverStateEnabled={true}
//                activeStateEnabled={true}
//                focusStateEnabled={true}
                onItemClick={onItemClick}
                selectedItemKeys={selectedItemKeys}
                selectionMode="single"
//                className="panel-list dx-theme-accent-as-background-color dx-state-focused"
                className="dx-state-focused"
            />
        </div>
    );
}

export default React.memo(NavigationList);